import React from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

const mapContainerStyle = {
  width: '100%',
  height: '300px',
  borderRadius: '8px'
};

const defaultCenter = {
  lat: 31.5497,
  lng: 74.3436
};

const SimpleMapDisplay = ({ 
  coordinates, 
  address = '', 
  sellerName = '',
  height = '300px' 
}) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  if (!isLoaded) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading map...</span>
        </div>
      </div>
    );
  }

  // Use provided coordinates or default to Lahore
  const mapCenter = coordinates && coordinates.lat && coordinates.lng ? coordinates : defaultCenter;
  const hasValidCoordinates = coordinates && coordinates.lat && coordinates.lng;

  return (
    <div className="simple-map-display">
      <GoogleMap
        mapContainerStyle={{ ...mapContainerStyle, height }}
        center={mapCenter}
        zoom={hasValidCoordinates ? 15 : 10}
        options={{
          gestureHandling: 'cooperative',
          disableDefaultUI: false,
          zoomControl: true,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: true
        }}
      >
        {hasValidCoordinates && (
          <Marker
            position={mapCenter}
            title={address || `${sellerName}'s Location`}
          />
        )}
      </GoogleMap>
      
      {address && (
        <div className="mt-2">
          <small className="text-muted">
            <i className="bi bi-geo-alt-fill me-1"></i>
            {address}
          </small>
        </div>
      )}
      
      {!hasValidCoordinates && (
        <div className="mt-2">
          <small className="text-warning">
            <i className="bi bi-exclamation-triangle-fill me-1"></i>
            Location not available
          </small>
        </div>
      )}
    </div>
  );
};

export default SimpleMapDisplay;